import * as React from "react"
import MegaMenu from "./megaMenu"
import { Href } from "../utils/helper"
import { Trans } from "../utils/lang"

const MenuAll = ({ menu }) => {
  // console.log(menu)

  return (
    <span className={`group px-4 cursor-pointer`}>
      <a className="text-base text-nowrap font-medium group-hover:text-gray-900 mt-4 md:mb-6 block group-hover:underline underline-offset-8 decoration-4">
        {Trans('menu')}
        <img src="/icons/header-menu-arrow-down.svg" alt="arrow-down" className="inline-block w-4 h-4 ml-2" />
      </a>
      <div className={`hidden group-hover:block absolute left-0 w-full bg-white z-[99] border-black border-t border-b`}>
        <div className="desktop-mega-menu container max-w-screen-xl flex flex-wrap mx-auto h-[600px] cursor-auto overflow-y-auto" 
          style={{scrollbarColor: 'black lightgray'}}>
          {menu.map((m, i) => (
            <div key={i} className="p-5">
              <a href={Href(m.link)} className="text-lg font-medium border-black border-b-4 hover:text-gray-500">
                {m.name}
              </a>
              { m.sub_menu && m.sub_menu.length > 0 &&
                <div className="flex flex-col">
                  {m.sub_menu.map((sub, j) => <MegaMenu blok={sub} key={j} linkOnly={true} />)}
                </div>
              }
            </div>
          ))}
        </div>
      </div>
    </span>
  )
}

export default MenuAll
